import { render, staticRenderFns } from "./BaseCurrencyInput.vue?vue&type=template&id=dffa1506"
import script from "./BaseCurrencyInput.vue?vue&type=script&lang=js"
export * from "./BaseCurrencyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports